module.exports = __webpack_public_path__ + "4e7df29b8f732a0d342eea97a05fb7ce.jpg";